"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.approvalRulesListResponseSchema = exports.approvalRulePriorityGroupSchema = exports.approvalRuleResponseSchema = exports.approvalRuleConditionResponseSchema = exports.duplicateApprovalRuleSchema = exports.toggleApprovalRuleSchema = exports.reorderApprovalRulesSchema = exports.updateApprovalRuleSchema = exports.createApprovalRuleSchema = exports.APPROVAL_RULE_NAME_MAX_LEN = exports.approvalRuleConditionInputSchema = exports.approvalRuleAllowlistResponseSchema = exports.approvalRuleFieldAllowlistEntrySchema = exports.approvalRuleEntityCatalogSchema = exports.approvalRuleEnumOptionSchema = exports.LIST_OPERATORS = exports.NULL_OPERATORS = exports.OPERATORS_BY_FIELD_KIND = exports.pgApproverRoleSchema = exports.PG_APPROVER_ROLES = exports.approvalRuleFieldKindSchema = exports.APPROVAL_RULE_FIELD_KINDS = exports.approvalRuleOperatorSchema = exports.APPROVAL_RULE_OPERATORS = exports.approvalModeSchema = exports.APPROVAL_MODES = exports.approvalEntityTypeSchema = exports.APPROVAL_ENTITY_TYPES = void 0;
exports.isOperatorSupportedForKind = isOperatorSupportedForKind;
exports.isNullOperator = isNullOperator;
exports.isListOperator = isListOperator;
const zod_1 = require("zod");
// Mirrors the Prisma `approval_entity_type` enum. The ORDER of the members
// differs from the database enum's; never index either positionally.
exports.APPROVAL_ENTITY_TYPES = [
    'ticket',
    'hedge_request',
    'inventory_match',
    'invoice',
    'document',
    'kyb_exception',
    'order_cancellation',
];
exports.approvalEntityTypeSchema = zod_1.z.enum(exports.APPROVAL_ENTITY_TYPES);
exports.APPROVAL_MODES = ['parallel', 'sequential'];
exports.approvalModeSchema = zod_1.z.enum(exports.APPROVAL_MODES);
exports.APPROVAL_RULE_OPERATORS = [
    'eq',
    'ne',
    'gt',
    'gte',
    'lt',
    'lte',
    'in',
    'not_in',
    'contains',
    'starts_with',
    'ends_with',
    'is_null',
    'is_not_null',
];
exports.approvalRuleOperatorSchema = zod_1.z.enum(exports.APPROVAL_RULE_OPERATORS);
exports.APPROVAL_RULE_FIELD_KINDS = ['numeric', 'string', 'boolean', 'enum', 'date'];
exports.approvalRuleFieldKindSchema = zod_1.z.enum(exports.APPROVAL_RULE_FIELD_KINDS);
exports.PG_APPROVER_ROLES = [
    'Hedging',
    'CFO',
    'Management',
    'Operations',
    'Risk_Manager',
    'COO',
];
exports.pgApproverRoleSchema = zod_1.z.enum(exports.PG_APPROVER_ROLES);
exports.OPERATORS_BY_FIELD_KIND = {
    numeric: ['eq', 'ne', 'gt', 'gte', 'lt', 'lte', 'in', 'not_in', 'is_null', 'is_not_null'],
    enum: ['eq', 'ne', 'in', 'not_in', 'is_null', 'is_not_null'],
    string: [
        'eq',
        'ne',
        'contains',
        'starts_with',
        'ends_with',
        'in',
        'not_in',
        'is_null',
        'is_not_null',
    ],
    boolean: ['eq', 'ne', 'is_null', 'is_not_null'],
    date: ['eq', 'ne', 'gt', 'gte', 'lt', 'lte', 'is_null', 'is_not_null'],
};
function isOperatorSupportedForKind(operator, kind) {
    return exports.OPERATORS_BY_FIELD_KIND[kind].includes(operator);
}
exports.NULL_OPERATORS = ['is_null', 'is_not_null'];
exports.LIST_OPERATORS = ['in', 'not_in'];
function isNullOperator(op) {
    return exports.NULL_OPERATORS.includes(op);
}
function isListOperator(op) {
    return exports.LIST_OPERATORS.includes(op);
}
exports.approvalRuleEnumOptionSchema = zod_1.z.object({
    value: zod_1.z.string(),
    label: zod_1.z.string(),
});
exports.approvalRuleEntityCatalogSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.array(exports.approvalRuleEnumOptionSchema));
exports.approvalRuleFieldAllowlistEntrySchema = zod_1.z.object({
    entity_type: exports.approvalEntityTypeSchema,
    field_name: zod_1.z.string(),
    field_kind: exports.approvalRuleFieldKindSchema,
    display_label: zod_1.z.string(),
    description: zod_1.z.string().nullable(),
    enum_type_name: zod_1.z.string().nullable(),
    enum_values: zod_1.z.array(exports.approvalRuleEnumOptionSchema).nullable(),
    catalog: exports.approvalRuleEntityCatalogSchema.nullable().optional(),
});
exports.approvalRuleAllowlistResponseSchema = zod_1.z.object({
    entries: zod_1.z.array(exports.approvalRuleFieldAllowlistEntrySchema),
});
const numericString = zod_1.z.string().regex(/^-?\d+(?:\.\d+)?$/, 'must be a number');
const isoDate = zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'must be ISO date YYYY-MM-DD');
const baseConditionShape = {
    field_name: zod_1.z.string().min(1).max(120),
    operator: exports.approvalRuleOperatorSchema,
    position: zod_1.z.number().int().min(0).optional(),
    value_text: zod_1.z.string().nullable().optional(),
    value_number: numericString.nullable().optional(),
    value_boolean: zod_1.z.boolean().nullable().optional(),
    value_date: isoDate.nullable().optional(),
    value_text_array: zod_1.z.array(zod_1.z.string()).default([]),
    value_number_array: zod_1.z.array(numericString).default([]),
    value_date_array: zod_1.z.array(isoDate).default([]),
};
function summariseConditionShape(cond) {
    const scalars = [cond.value_text, cond.value_number, cond.value_boolean, cond.value_date];
    const arrays = [cond.value_text_array, cond.value_number_array, cond.value_date_array];
    return {
        filledScalars: scalars.filter((v) => v !== null && v !== undefined).length,
        filledArrays: arrays.filter((v) => v.length > 0).length,
    };
}
function refineConditionShape(cond, ctx) {
    const { filledScalars, filledArrays } = summariseConditionShape(cond);
    const op = cond.operator;
    const addIssue = (message) => {
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, message, path: ['operator'] });
    };
    if (isNullOperator(op)) {
        if (filledScalars > 0 || filledArrays > 0) {
            addIssue(`operator '${op}' must not carry any value`);
        }
        return;
    }
    if (isListOperator(op)) {
        if (filledScalars > 0)
            addIssue(`operator '${op}' must use an array, not a scalar value`);
        if (filledArrays !== 1)
            addIssue(`operator '${op}' requires exactly one non-empty value_*_array`);
        return;
    }
    if (filledArrays > 0)
        addIssue(`operator '${op}' must use a scalar value, not an array`);
    if (filledScalars !== 1)
        addIssue(`operator '${op}' requires exactly one non-null scalar value`);
}
const rawConditionSchema = zod_1.z.object(baseConditionShape).strict();
exports.approvalRuleConditionInputSchema = rawConditionSchema.superRefine(refineConditionShape);
exports.APPROVAL_RULE_NAME_MAX_LEN = 80;
const ruleBodyShape = {
    name: zod_1.z.string().trim().min(1).max(exports.APPROVAL_RULE_NAME_MAX_LEN),
    description: zod_1.z
        .string()
        .trim()
        .max(2000)
        .nullable()
        .optional()
        .transform((v) => (v === undefined || v === null || v.length === 0 ? null : v)),
    entity_type: exports.approvalEntityTypeSchema,
    mode: exports.approvalModeSchema.default('parallel'),
    required_approvers: zod_1.z.array(exports.pgApproverRoleSchema).min(1).max(exports.PG_APPROVER_ROLES.length),
    conditions: zod_1.z.array(exports.approvalRuleConditionInputSchema).default([]),
};
exports.createApprovalRuleSchema = zod_1.z.object(ruleBodyShape).strict();
exports.updateApprovalRuleSchema = zod_1.z
    .object({
    name: ruleBodyShape.name,
    description: ruleBodyShape.description,
    mode: ruleBodyShape.mode,
    required_approvers: ruleBodyShape.required_approvers,
    conditions: ruleBodyShape.conditions,
})
    .strict();
exports.reorderApprovalRulesSchema = zod_1.z
    .object({
    entity_type: exports.approvalEntityTypeSchema,
    expected_version: zod_1.z.number().int().min(0),
    rule_ids: zod_1.z
        .array(zod_1.z.string().uuid())
        .min(1)
        .refine((ids) => new Set(ids).size === ids.length, {
        message: 'rule_ids must not contain duplicates',
    }),
})
    .strict();
exports.toggleApprovalRuleSchema = zod_1.z.object({ is_enabled: zod_1.z.boolean() }).strict();
exports.duplicateApprovalRuleSchema = zod_1.z
    .object({
    target_entity_type: exports.approvalEntityTypeSchema,
    resolved_conditions: zod_1.z.array(exports.approvalRuleConditionInputSchema).optional(),
})
    .strict();
exports.approvalRuleConditionResponseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    field_name: zod_1.z.string(),
    operator: exports.approvalRuleOperatorSchema,
    position: zod_1.z.number().int(),
    value_text: zod_1.z.string().nullable(),
    value_number: zod_1.z.string().nullable(),
    value_boolean: zod_1.z.boolean().nullable(),
    value_date: zod_1.z.string().nullable(),
    value_text_array: zod_1.z.array(zod_1.z.string()),
    value_number_array: zod_1.z.array(zod_1.z.string()),
    value_date_array: zod_1.z.array(zod_1.z.string()),
});
exports.approvalRuleResponseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable(),
    entity_type: exports.approvalEntityTypeSchema,
    mode: exports.approvalModeSchema,
    required_approvers: zod_1.z.array(exports.pgApproverRoleSchema),
    priority: zod_1.z.number().int(),
    is_enabled: zod_1.z.boolean(),
    field_set_version: zod_1.z.number().int(),
    created_at: zod_1.z.string(),
    updated_at: zod_1.z.string(),
    conditions: zod_1.z.array(exports.approvalRuleConditionResponseSchema),
});
exports.approvalRulePriorityGroupSchema = zod_1.z.object({
    entity_type: exports.approvalEntityTypeSchema,
    version: zod_1.z.number().int(),
});
exports.approvalRulesListResponseSchema = zod_1.z.object({
    rules: zod_1.z.array(exports.approvalRuleResponseSchema),
    priority_groups: zod_1.z.array(exports.approvalRulePriorityGroupSchema),
});
//# sourceMappingURL=approval-rules.js.map